import { PropaneSharp } from "@mui/icons-material";
import React from "react";

const About = (props) => {
  return (
    <>
      <div className="row align-items-center justify-content-center">
                <div className="row justify-content-center section-title">
          <div className="col-lg-7">
            <div className="about-us-div" style={{textAlign:"center"}}>
            <h3 className="font-alt">{props.site.aboutUsPageTitle}</h3>
            <p className="body">{props.site.aboutUsDescription}</p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-6 my-3"
          data-aos="fade-up"
          data-aos-duration="1200"
        >
          {/* <div className="img-box">
            <img src={process.env.PUBLIC_URL + "img/bannerbackground.jpg"} alt="smiling a girl" />
            
          </div> */}
        </div>

        {/* <div
          className="col-lg-7"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="100"
          style={{paddingLeft:"3rem", paddingRight:"3rem"}}
        >
          <div className="typo-box about-me">





            
            <h3 className="section-title">Section Title</h3>
            <p>
              I design and develop services for customers of all sizes,
              specializing in creating stylish, modern websites, web services
              and online stores. My passion is to design digital user
              experiences through the bold interface and meaningful
              interactions. Check out my Portfolio
                            I design and develop services for customers of all sizes,
              specializing in creating stylish, modern websites, web services
              and online stores. My passion is to design digital user
              experiences through the bold interface and meaningful
              interactions. Check out my Portfolio
                            I design and develop services for customers of all sizes,
              specializing in creating stylish, modern websites, web services
              and online stores. My passion is to design digital user
              experiences through the bold interface and meaningful
              interactions. Check out my Portfolio
            </p>

          </div>
        </div> */}
      </div>
    </>
  );
};

export default About;
